import request from '@/utils/request'

// ==================== 认证相关接口 ====================
// 接口前缀：/admin/auth/session + /admin/auth/profile
// 响应拦截器已统一处理 code/msg，这里返回的是后端完整 res（含 code/msg/data），业务数据取 res.data

/**
 * 登录
 * @param {Object} data
 * @param {string} data.username - 用户名
 * @param {string} data.password - 密码
 * @param {string} [data.captcha_code] - 验证码（开启验证码时必填）
 * @param {string} [data.captcha_key] - 验证码缓存key（获取验证码接口返回）
 * @returns {Promise} res - 后端响应体，res.data 含 token / admin_info / role_codes / permission_codes / is_super_admin / menus
 */
export function login(data) {
  return request({
    url: '/admin/auth/session/login',
    method: 'post',
    data
  })
}

/**
 * 获取验证码
 * @returns {Promise} res - res.data 含 enabled / key / image
 */
export function getCaptcha() {
  return request({
    url: '/admin/auth/session/captcha',
    method: 'get'
  })
}

/**
 * 获取当前登录用户信息（含菜单树）
 * @returns {Promise} res - res.data 含 id / username / real_name / avatar_file_id / status / menus
 */
export function getInfo() {
  return request({
    url: '/admin/auth/session/info',
    method: 'get'
  })
}

/**
 * 退出登录
 * @returns {Promise} res
 */
export function logout() {
  return request({
    url: '/admin/auth/session/logout',
    method: 'post'
  })
}

/**
 * 获取个人资料（含手机号、邮箱等敏感信息）
 * @returns {Promise} res - res.data 含 id / username / real_name / phone / email / avatar_file_id / status / last_login_time / last_login_ip / create_time / update_time
 */
export function getProfile() {
  return request({
    url: '/admin/auth/profile/read',
    method: 'get'
  })
}

/**
 * 更新个人资料（仅 real_name / phone / email / avatar_file_id，修改后自动清除 Info 缓存）
 * @param {Object} data
 * @param {string} [data.real_name] - 真实姓名
 * @param {string} [data.phone] - 手机号（中国大陆格式）
 * @param {string} [data.email] - 邮箱
 * @param {Object} [data.avatar_file_id] - 头像对象 {file_id, file_url}
 * @returns {Promise} res
 */
export function updateProfile(data) {
  return request({
    url: '/admin/auth/profile/update',
    method: 'post',
    data
  })
}

/**
 * 修改密码（需验证旧密码，成功后清除 Token 缓存，强制重新登录）
 * @param {Object} data
 * @param {string} data.old_password - 旧密码
 * @param {string} data.new_password - 新密码（6-72 位）
 * @param {string} data.confirm_password - 确认新密码（须与 new_password 一致）
 * @returns {Promise} res
 */
export function changePassword(data) {
  return request({
    url: '/admin/auth/profile/password',
    method: 'post',
    data
  })
}
